module.exports = __webpack_public_path__ + "media/Whale.bba2e9f5.mp3";